import React, { useEffect, useState } from 'react'
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  MenuItem,
  Popover,
  Select,
  Tooltip,
} from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import {
  MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS,
  ncbValueObjectList,
} from 'src/utils/constants/BuyPolicyMotor'
import {
  updateCurrentPolicyDetailsMotor,
  updatePreviousPolicyDetailsMotor,
} from 'src/actions'
import IDVCoverTile from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetailsTiles/IDVCoverTile'
import { POLICY_STATUS_SMALLCASE } from 'src/utils/constants/Bike'

const ExploreVehicleDetailsTile = ({ addOnsList }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const previousPolicyDetails = motorDetails?.previousPolicyDetails
  const vehicleDetails = motorDetails?.vehicleDetails
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const [selectedAddOns, setSelectedAddOns] = useState(
    currentPolicyDetails ? currentPolicyDetails?.selectedAddOns : []
  )
  const [selectedAddOnIds, setSelectedAddOnIds] = useState(
    currentPolicyDetails ? currentPolicyDetails?.addOns : []
  )
  const [popoverElement, setPopoverElement] = useState('')
  const [anchorElEditPopover, setAnchorElEditPopover] = React.useState(null)
  const openEditPopover = Boolean(anchorElEditPopover)
  const idEditPopover = openEditPopover ? 'simple-popover-edit' : undefined

  const handleCheck = (bike) => {
    if (selectedAddOnIds?.includes(bike?.id)) {
      setSelectedAddOnIds(selectedAddOnIds?.filter((id) => id !== bike?.id))
      setSelectedAddOns(
        selectedAddOns?.filter((selectedBike) => selectedBike?.id !== bike?.id)
      )
    } else {
      setSelectedAddOnIds([...selectedAddOnIds, bike?.id])
      setSelectedAddOns([...selectedAddOns, bike])
    }
  }
  const handleClickEditPopover = (event) => {
    setAnchorElEditPopover(event?.currentTarget)
  }
  const handleCloseEditPopover = () => {
    setAnchorElEditPopover(null)
  }
  const handleEditPopoverClick = (event, element) => {
    setPopoverElement(element)
    handleClickEditPopover(event)
  }
  const getEditPopoverComponent = () => {
    if (MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_IDV === popoverElement) {
      return (
        <>
          <Box>
            <IDVCoverTile />
          </Box>
        </>
      )
    } else {
      return
    }
  }

  useEffect(() => {
    dispatch(
      updateCurrentPolicyDetailsMotor({
        ...currentPolicyDetails,
        addOns: selectedAddOnIds,
        selectedAddOns: selectedAddOns,
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddOnIds, selectedAddOns])

  return (
    <Box>
      <Popover
        id={idEditPopover}
        open={openEditPopover}
        anchorEl={anchorElEditPopover}
        onClose={handleCloseEditPopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className={classes.vehicleDetailsPopover}
      >
        <Box>{getEditPopoverComponent()}</Box>
      </Popover>
      <Box className={classes.exploreBikeDetailsContainer}>
        <Box className={classes.vehicleDetailsCardExplore}>
          <Box className={classes.brandDetailsExplore}>
            <Box className={classes.exploreVehicleLogo}>
              <img
                src={vehicleDetails?.vehicleLogo}
                alt={'brandLogo'}
                className={classes.logo}
              />
            </Box>
            <Box className={classes.brandTextExplore}>
              {vehicleDetails?.brand?.genericName}
            </Box>
            <Box className={classes.modelTextExplore}>
              {vehicleDetails?.model?.modelGenericName}
            </Box>
            <Box className={classes.vehicleNumberTextExplore}>
              {vehicleDetails?.vehicleNumber}(
              {motorDetails?.personalDetails?.city})
            </Box>
          </Box>
          <Box className={classes.fuelDetailsExplore}>
            <Box className={classes.dateTextExplore}>
              {formatDateMonth(vehicleDetails?.regDate)}
            </Box>
            <Box className={classes.dateTextExplore}>
              {motorDetails?.vehicleDetails?.variant?.genericVariantName || ''}
            </Box>
          </Box>
        </Box>
        <Divider variant='middle' flexItem />
        <Box className={classes.policyNotExpiredSectionExplore}>
          <Box className={classes.policyNotExpiredTextExplore}>
            {previousPolicyDetails?.isPolicyExpired ===
            POLICY_STATUS_SMALLCASE?.EXPIRED
              ? 'Policy Expired'
              : 'Policy Not Expired'}
          </Box>
          <Divider />
        </Box>
        <Divider variant='middle' flexItem />
        <Box className={classes.sectionColumnExplore}>
          <Box className={classes.sectionHeadingExplore}>
            IDV Cover (Insured Value)
          </Box>
          <Box className={classes.sectionDataExplore}>
            <Box className={classes.sectionRowExplore}>
              <Box>
                {formatToINR(
                  motorDetails?.currentPolicyDetails?.idv
                    ? motorDetails?.currentPolicyDetails?.idv
                    : motorDetails?.currentPolicyDetails?.idvMaxValue
                )}
              </Box>
              <ExpandMoreIcon
                fontSize='small'
                className={classes.expandIconExplore}
                onClick={(e) =>
                  handleEditPopoverClick(
                    e,
                    MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_IDV
                  )
                }
              />
            </Box>
            <Box className={classes.recommendedIDVExplore}>Recommended IDV</Box>
          </Box>
        </Box>
        <Divider variant='middle' flexItem />

        <Box className={classes.featureContextExplore}>
          {addOnsList?.map((bike) => {
            return (
              <>
                <Box
                  className={classes.featureContentExplore}
                  key={`feature_${bike?.title}`}
                >
                  <Box className={classes.featureChecklistExplore}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          className={classes.checkListExplore} // Change the color to 'secondary' for a different style
                          size='small'
                          checked={selectedAddOnIds?.includes(bike?.id)} // Check based on whether the ID is in the selectedAddOnIds array
                          onChange={() => handleCheck(bike)} // Call handleCheck function with the motor object
                        />
                      }
                      label={
                        <Tooltip
                          placement='right-start'
                          arrow
                          title={
                            bike?.description ? (
                              <>
                                <Box>{bike?.description}</Box>
                              </>
                            ) : null
                          }
                        >
                          <Box className={classes.checkTitleExplore}>
                            {bike?.coverage}
                          </Box>
                        </Tooltip>
                      }
                    />
                  </Box>
                </Box>
                <Divider variant='middle' flexItem />
              </>
            )
          })}
        </Box>

        <Box className={classes.sectionColumnExplore}>
          <Box className={classes.sectionHeadingExplore}>
            No Claim Bonus (NCB)
          </Box>
          <Box className={classes.sectionDataExplore}>
            <Box className={classes.sectionRowExplore}>
              <Box className={classes.ncbContainer}>
                <FormControl>
                  {!previousPolicyDetails?.previousPolicyClaim ? (
                    <Select
                      id='ncbValue'
                      name='ncbValue'
                      className={classes.inputTextField}
                      value={previousPolicyDetails?.ncb}
                      onChange={(e) =>
                        dispatch(
                          updatePreviousPolicyDetailsMotor({
                            ...previousPolicyDetails,
                            ncb: e?.target?.value,
                          })
                        )
                      }
                      size='small'
                    >
                      {ncbValueObjectList?.map((item) => {
                        return (
                          <MenuItem value={item?.value} key={item?.value}>
                            {item?.option}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  ) : (
                    <div>0%</div>
                  )}
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ExploreVehicleDetailsTile

const useStyles = makeStyles({
  exploreBikeDetailsContainer: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px 0px #00000033',
    width: '297px',
    borderRadius: '10px',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 30,
  },
  vehicleDetailsCardExplore: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    gap: 15,
  },
  brandDetailsExplore: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fuelDetailsExplore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: 30,
  },
  brandTextExplore: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#9D9D9D',
  },
  modelTextExplore: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17.81px',
    letterSpacing: '0em',
    color: '#272727',
  },
  vehicleNumberTextExplore: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '16.53px',
    letterSpacing: '0em',
    color: '#7A7A7A',
  },
  dateTextExplore: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  exploreVehicleLogo: {
    padding: '10px 0px 10px 0px',
  },
  logo: { width: '90px', height: '50px' },
  policyNotExpiredSectionExplore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 7,
    padding: '10px 0px 10px 15px',
  },
  policyNotExpiredTextExplore: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16.41px',
    letterSpacing: '0em',
  },
  editIconPolicyNotExpiredExplore: {
    color: '#2BACCF',
    fontSize: '15px !important',
    cursor: 'pointer',
  },
  editIconExplore: {
    color: '#2BACCF',
    fontSize: '15px !important',
    position: 'absolute',
    right: '0',
    top: '0',
    cursor: 'pointer',
  },
  sectionColumnExplore: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
    padding: '10px 0px 10px 15px',
  },
  sectionHeadingExplore: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#939393',
  },
  sectionDataExplore: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19px',
    letterSpacing: '0em',
    marginRight: 'auto',
  },
  recommendedIDVExplore: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#939393',
  },
  sectionRowExplore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  expandIconExplore: {
    color: '#2BACCF',
    cursor: 'pointer',
  },
  checkListExplore: {
    color: '#A4BDC3',
  },
  checkTitleExplore: {
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  featureSpanContentExplore: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#7A7A7A',
  },
  featureContentExplore: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0px 5px 15px',
  },

  featureChecklistExplore: {
    paddingTop: '1%',
  },
  ncbContainer: {
    paddingTop: 5,
  },
})
